<template>
  <div class ="ClientManage">
    <cmForm :clients="clients" />
  </div>
</template>

<script>
  import cmForm from '@/components/clientmanagecomps/cmForm';
  import {mapActions, mapGetters} from 'vuex';
  export default {
    mounted () {
      //get clients list
      this.generateClientList();
    },
    computed: mapGetters({
        clients: 'getClientList',
    }),
    methods: {
        ...mapActions(['generateClientList'])
    },
    components: { cmForm },
  };
</script>
